import {
  Modal,
  Input,
  Upload,
  Button,
  Form,
  message,
  Select,
  Row,
  Col,
  Spin,
} from "antd";
import { useEffect, useState } from "react";
import { bg_button, bg_shadow } from "constant/css";

import SubMerchantSelect from "components/select/subMerchant";
import CreatePos from "functions/admin/createPos";
import UpdatePos from "functions/admin/updatePos";

const suppliers = [
  { id: "DATABANK", name: "Дата банк" },
  { id: "NEGDI", name: "Negdi" },
];
const AddPos = ({ pos, open, onClose, refresh }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    setLoading(true);
    if (pos) {
      fillData(pos);
    } else {
      form.resetFields();
      setLoading(false);
    }
  }, [pos]);
  const handleSubmit = async () => {
    if (pos) update();
    else create();
  };
  const create = async () => {
    try {
      setLoading(true);
      const values = await form.validateFields();
      if (!values.supplier || !values.mark || !values.vatMerchantId) {
        message.error("Бүх талбарыг бөглөнө үү.");
      }
      const response = await CreatePos({ ...values, status: "ACTIVE" });
      if (response && response.data) {
        form.resetFields();
        refresh();
        onClose();
      } else {
        message.error("Failed to save function.");
      }
    } catch (err) {
      console.log(err);
      message.error("Please complete the form.");
    } finally {
      setLoading();
    }
  };
  const update = async () => {
    try {
      setLoading(true);
      const values = await form.validateFields();
      if (!values.supplier || !values.mark || !values.vatMerchantId) {
        message.error("Бүх талбарыг бөглөнө үү.");
      }
      console.log("Form values:", values);
      const response = await UpdatePos({
        ...pos,
        ...values,
      });
      console.log("Submitted function:", response.data);
      if (response && response.data) {
        form.resetFields();
        refresh();
        onClose();
      } else {
        message.error("Failed to save function.");
      }
    } catch (err) {
      console.log(err);
      message.error("Please complete the form.");
    } finally {
      setLoading();
    }
  };
  const fillData = () => {
    form.setFieldsValue({ ...pos, vatMerchantId: pos.vatMerchant.id });
    setTimeout(() => {
      setLoading(false);
    }, 500);
  };
  return (
    <Modal
      open={open}
      title={pos ? "Засах" : "Шинэ пос"}
      onCancel={onClose}
      onOk={handleSubmit}
      footer={null}
    >
      <Form layout="vertical" form={form}>
        <Row gutter={12}>
          <Col span={12}>
            <Form.Item
              name="supplier"
              label="Нийлүүлэгч"
              rules={[{ required: true }]}
            >
              <Select>
                {suppliers.map((supplier) => (
                  <Select.Option key={supplier.id} value={supplier.id}>
                    {supplier.name}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item name="mark" label="Загвар" rules={[{ required: true }]}>
              <Input placeholder="Жишээ: Ingenico iCT250" />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={12}>
          <Col span={12}>
            {!loading ? (
              <Form.Item
                name="vatMerchantId"
                label="Дэд мерчант"
                rules={[{ required: true }]}
              >
                <SubMerchantSelect />
              </Form.Item>
            ) : (
              <Spin />
            )}
          </Col>
          <Col span={12}>
            <Form.Item name="status" label="Төлөв" rules={[{ required: true }]}>
              <Select>
                <Select.Option>Идэвхтэй</Select.Option>
                <Select.Option>Идэвхгүй</Select.Option>
              </Select>
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              name="transactionName"
              label="Хуулганы таних нэр"
              rules={[{ required: true }]}
            >
              <Input placeholder="" />
            </Form.Item>
          </Col>
        </Row>
        <div className="flex flex-row mt-10 justify-center gap-2">
          <Button
            className={`text-red-400 border-1 border-red-200 hover:bg-red-100`}
            onClick={onClose}
          >
            Хаах
          </Button>
          <Form.Item>
            <Button
              type="primary"
              className={`${bg_button} text-white border-none ${bg_shadow}`}
              onClick={handleSubmit}
            >
              {pos ? "Засах" : "Нэмэх"}
            </Button>
          </Form.Item>
        </div>
      </Form>
    </Modal>
  );
};

export default AddPos;
